import { HttpResponseMock, HttpResponseMockType, createHttpAction } from '@raisin/cp-utils';
import { identifyUserBy } from '@raisin/events-tracking';
import { NewsletterApiResponse, StatusCallbackProps, SubmitRequestProps } from './types';

export const getResponseStatusHandler = (
  res: NewsletterApiResponse,
  { formDisplayHandler, setResponse }: StatusCallbackProps,
) => {
  if (res.status === 'subscribed') {
    formDisplayHandler();
    setResponse({
      ...res,
      status: '200',
    });
  } else {
    setResponse(res);
  }
};
export const getResponseCodes = (messages, formatMessage: Function) => ({
  '412': formatMessage(messages.NewsletterEnterAValidEmailAddress),
  '422': formatMessage(messages.NewsletterSubscriptionCannotBeProcessed), //'422 Unprocessable Entity',
  '502': formatMessage(messages.NewsletterSubscriptionCannotBeProcessed), //'502 Bad Gateway',
  '503': formatMessage(messages.NewsletterSubscriptionCannotBeProcessed), //'503 Service Unavailable',
});

export const submitRequest = async ({
  request,
  email,
  successHandler,
  errorHandler,
}: SubmitRequestProps) => {
  try {
    const mockedResponse = {
      id: {
        email: 'user@example.com',
      },
      status: 'subscribed',
    };

    const subscriptionMock: HttpResponseMock = {
      data: mockedResponse,
      type: HttpResponseMockType.RESOLVE,
    };

    const response = await createHttpAction(request, subscriptionMock);
    successHandler(response.data as NewsletterApiResponse);
    if (email) {
      identifyUserBy('email', email);
    }
  } catch (e: any) {
    errorHandler(e);
  }
};
